import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import { getParent, types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
import moment from 'moment';
import { toJS } from 'mobx';
const searchUtilityProvidersAsync = createAsync(searchKey => {
  return async function searchUtilityProviders(data, options) {
    const resp = await api.UtilityProviders.searchUtilityProviders({
      searchKey
    }, options);
    return resp;
  };
});
const searchUtilityProvidersPlainAsync = createAsync(searchKey => {
  return async function searchUtilityProviders(data, options) {
    const resp = await api.UtilityProviders.searchUtilityProviders({
      searchKey
    }, options);
    return resp;
  };
});
const getUtilityProvidersAsync = createAsync(_ref => {
  let utilityProviderId = _ref.utilityProviderId,
    _ref$storeAsFetched = _ref.storeAsFetched,
    storeAsFetched = _ref$storeAsFetched === void 0 ? false : _ref$storeAsFetched,
    _ref$updateStore = _ref.updateStore,
    updateStore = _ref$updateStore === void 0 ? true : _ref$updateStore;
  return async function getUtilityProviders(data, options) {
    const resp = await api.UtilityProviders.getUtilityProvider({
      utilityProviderId
    }, options);
    if (updateStore) {
      getParent(this).addNewProperty.utilitiesSetupV2.addProvider(resp.response, storeAsFetched);
    }
    return resp;
  };
});
const getUtilityProvidersListDataAsync = createAsync(_ref2 => {
  let utilityProviderIds = _ref2.utilityProviderIds;
  return async function getUtilityProvidersListData(data, options) {
    const resp = await api.UtilityProviders.getUtilityProvidersList({
      utilityProviderIds
    }, options);
    return resp;
  };
});
const getPropertyCommonAreaAmenitiesAsync = createAsync(_ref3 => {
  let propertyId = _ref3.propertyId;
  return async function getPropertyCommonAreaAmenities(data, options) {
    const resp = await api.Properties.getPropertyCommonAreaAmenity({
      propertyId
    }, options);
    return resp;
  };
});
const patchPropertyCommonAreaAmenitiesAsync = createAsync(_ref4 => {
  let propertyId = _ref4.propertyId,
    toCreate = _ref4.toCreate,
    toUpdate = _ref4.toUpdate,
    toDelete = _ref4.toDelete;
  return async function patchPropertyCommonAreaAmenities(data, options) {
    const resp = await api.Properties.patchPropertyCommonAreaAmenities({
      propertyId,
      toCreate,
      toUpdate,
      toDelete
    }, options);
    return resp;
  };
});
const addCustomUtilityProvidersAsync = createAsync(_ref5 => {
  let name = _ref5.name,
    website = _ref5.website,
    propertyId = _ref5.propertyId;
  return async function addCustomUtilityProviders(data, options) {
    const resp = await api.UtilityProviders.addUtilityProviders({
      name,
      website,
      propertyId
    }, options);
    return resp;
  };
});
const addCustomUtilityProvidersV2Async = createAsync(_ref6 => {
  let name = _ref6.name,
    website = _ref6.website,
    propertyId = _ref6.propertyId,
    utilityTypeIds = _ref6.utilityTypeIds;
  return async function addCustomUtilityProviders(data, options) {
    const resp = await api.UtilityProviders.addUtilityProvidersV2({
      name,
      website,
      propertyId,
      utilityTypeIds
    }, options);
    return resp;
  };
});
const editCustomUtilityProvidersAsync = createAsync(_ref7 => {
  let name = _ref7.name,
    website = _ref7.website,
    providerId = _ref7.providerId,
    propertyId = _ref7.propertyId;
  return async function editCustomUtilityProviders(data, options) {
    const resp = await api.UtilityProviders.editUtilityProviders({
      name,
      website,
      providerId,
      propertyId
    }, options);
    await getParent(this).utilityProviders.getUtilityProvidersAsync.run({
      utilityProviderId: providerId
    });
    return resp;
  };
});
const getAllUtilityTypesAsync = createAsync(_ref8 => {
  _objectDestructuringEmpty(_ref8);
  return async function getAllUtilityTypes(data, options) {
    const _getParent = getParent(this),
      utilityProviders = _getParent.utilityProviders;
    if (utilityProviders.utilityTypesCache === null || utilityProviders.utilityTypesCache.lastUpdateTime && moment().diff(moment(utilityProviders.utilityTypesCache.lastUpdateTime), 'minutes') >= 5) {
      const resp = await api.UtilityProviders.getAllUtilityTypes({}, options);
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        await utilityProviders.setUtilityCacheLoad(resp.response);
      }
      return resp;
    } else {
      return {
        isSuccessful: true,
        response: utilityProviders.utilityTypesCache.utilitiesValue.map(i => toJS(i))
      };
    }

    // return resp;
  };
});
const getUtilityInfoAsync = createAsync(_ref9 => {
  let utilityIds = _ref9.utilityIds;
  return async function getUtilityInfo(data, options) {
    const resp = await api.UtilityProviders.getUtilityInfo({
      utilityIds
    }, options);
    const _getParent2 = getParent(this),
      utilityProviders = _getParent2.utilityProviders,
      addNewProperty = _getParent2.addNewProperty;
    await utilityProviders.setUtilityAfterLoad(resp);
    await addNewProperty.utilitiesSetupV2.updateUtilsDefaults(resp);
    return resp;
  };
});
const getPropertyUtilityInfoAsync = createAsync(_ref0 => {
  let utilityIds = _ref0.utilityIds,
    propertyId = _ref0.propertyId;
  return async function getUtilityInfo(data, options) {
    const resp = await api.PropertyUtility.getPropertyUtilityInfoByUtilityAndProperty({
      utilityIds,
      propertyId
    }, options);
    const _getParent3 = getParent(this),
      utilityProviders = _getParent3.utilityProviders,
      addNewProperty = _getParent3.addNewProperty;
    await utilityProviders.setUtilityAfterLoad(resp);
    await addNewProperty.utilitiesSetupV2.updateUtilsDefaults(resp);
    return resp;
  };
});
const createCustomUtilityTypeAsync = createAsync(_ref1 => {
  let name = _ref1.name,
    defaultAllocationMethod = _ref1.defaultAllocationMethod,
    paidBy = _ref1.paidBy,
    cad = _ref1.cad;
  return async function createCustomUtilityType(data, options) {
    const resp = await api.UtilityProviders.postCustomUtilityType({
      name,
      defaultAllocationMethod,
      paidBy,
      cad
    }, options);
    return resp;
  };
});
const updateCustomUtilityTypeAsync = createAsync(_ref10 => {
  let name = _ref10.name,
    utilityTypeId = _ref10.utilityTypeId;
  return async function updateCustomUtilityType(data, options) {
    const resp = await api.UtilityProviders.putCustomUtilityType({
      name,
      utilityTypeId
    }, options);
    return resp;
  };
});
const createCustomUtilityTypeAndAttachToProviderAsync = createAsync(_ref11 => {
  let name = _ref11.name,
    defaultAllocationMethod = _ref11.defaultAllocationMethod,
    paidBy = _ref11.paidBy,
    cad = _ref11.cad,
    utilityProviderId = _ref11.utilityProviderId,
    defaultVacantUnitUsage = _ref11.defaultVacantUnitUsage;
  return async function createCustomUtilityTypeAndAttachToProvider(data, options) {
    const resp = await api.UtilityProviders.postCustomUtilityTypeAndAttach({
      name,
      defaultAllocationMethod,
      paidBy,
      cad,
      utilityProviderId,
      defaultVacantUnitUsage
    }, options);
    return resp;
  };
});
const Utility = types.model('Utility', {
  cad: types.maybeNull(types.boolean),
  defaultAllocationMethod: types.maybeNull(types.string),
  paidBy: types.maybeNull(types.string),
  defaultVacantUnitUsage: types.maybeNull(types.string),
  providerName: types.optional(types.string, ''),
  utilityTypeId: types.optional(types.string, ''),
  utilityTypeName: types.optional(types.string, '')
});
const UtilityProvidersStore = types.model('UtilityProvidersStore', {
  addCustomUtilityProvidersAsync,
  addCustomUtilityProvidersV2Async,
  editCustomUtilityProvidersAsync,
  createCustomUtilityTypeAsync,
  updateCustomUtilityTypeAsync,
  createCustomUtilityTypeAndAttachToProviderAsync,
  getPropertyCommonAreaAmenitiesAsync,
  getUtilityInfoAsync,
  getUtilityProvidersAsync,
  getUtilityProvidersListDataAsync,
  patchPropertyCommonAreaAmenitiesAsync,
  searchUtilityProvidersAsync,
  searchUtilityProvidersPlainAsync,
  getAllUtilityTypesAsync,
  getPropertyUtilityInfoAsync,
  utilitiesValue: types.map(Utility),
  utilityTypesCache: types.maybeNull(types.model('UtilityTypesCache', {
    lastUpdateTime: types.number,
    utilitiesValue: types.optional(types.array(Utility), [])
  }))
}).actions(self => ({
  setUtilityAfterLoad(data) {
    try {
      data.response.utilities.forEach(item => {
        self.utilitiesValue.set(item.utilityId, {
          cad: item.cad,
          defaultAllocationMethod: item.defaultAllocationMethod,
          defaultVacantUnitUsage: item.defaultVacantUnitUsage,
          paidBy: item.paidBy,
          providerName: item.providerName,
          utilityTypeId: item.utilityTypeId,
          utilityTypeName: item.utilityTypeName
        });
      });
    } catch (error) {
      console.log('STORE ERROR > setUtilityAfterLoad', error);
    }
  },
  setUtilityCacheLoad(data) {
    try {
      self.utilityTypesCache = {
        lastUpdateTime: moment().toDate().getTime(),
        utilitiesValue: data.map(item => {
          return {
            cad: item.cad,
            defaultAllocationMethod: item.defaultAllocationMethod,
            defaultVacantUnitUsage: item.defaultVacantUnitUsage,
            paidBy: item.paidBy,
            providerName: item.providerName,
            utilityTypeId: item.utilityTypeId,
            utilityTypeName: item.utilityTypeName
          };
        })
      };
    } catch (error) {
      console.log('STORE ERROR > setUtilityCacheLoad', error);
    }
  }
})).views(self => ({
  get utilities() {
    return self.utilitiesValue;
  }
}));
export const utilityProviders = types.optional(UtilityProvidersStore, {});